<template>
  <!-- 注册审核 -->
  <div class="registAudit">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['客户管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="客户状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option
            v-for="(item, index) in itemList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
        ></el-input>
        <el-button type="primary" @click="seach" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="businessname"
        align="center"
        show-overflow-tooltip
        label="客户名称"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="clinettype"
        label="客户分类"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="telphone"
        label="联系方式"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="province"
        label="省"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="city"
        label="市"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="prefecture"
        label="区"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        width="160"
        label="注册时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="lastmodifytime"
        width="160"
        label="最后更新时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="statusname"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="200"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span
          ><i
            class="el-icon-edit"
            style="font-size: 16px; color: #409eff; cursor: pointer"
            @click="AuditRemeark(scope.row)"
          ></i>
          <!-- <el-input
            v-model="scope.row.remark"
            style="width: 150px"
            placeholder="请输入备注"
          ></el-input> -->
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            plain
            style="padding: 2px 3px"
            v-if="scope.row.status == 1"
            @click="handleAudit(scope.row)"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "registAudit",
  data() {
    return {
      /**表格数据 */
      // {
      //   organCode:"机构编码",
      //   organName:"机构名称",
      //   name:"姓名",
      //   tel:"联系方式",
      //   province:"省",
      //   city:"市",
      //   area:"区",
      //   status:"状态"
      // }
      tableData: [],
      /**搜索表单 */
      searchForm: {
        name: "",
        status: "1",
      },
      itemList: [
        {
          value: "99",
          label: "全部",
        },
        {
          value: "0",
          label: "已拒审",
        },
        {
          value: "1",
          label: "未审核",
        },
        {
          value: "2",
          label: "已审核",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    // 搜索表格数据
    seach() {
      this.getTableData(1);
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "PC_Register",
        startDate: "",
        endDate: "",
        status: this.searchForm.status,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_MembersQuery"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 修改备注
    AuditRemeark(row) {
      this.$prompt("请输入备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.$request({
            method: "post",
            url: "/Management/MemberAdmin/EditRegistRemark",
            data: {
              UserId: row.userid,
              Remark: value,
            },
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "warning",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "warning",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**点击审核按钮 */
    handleAudit(row) {
      let prams = null;
      prams = encodeURIComponent(JSON.stringify({ id: row.userid }));
      this.$router.push({
        path: "audit",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
  },
};
</script>

<style scoped>
.registAudit {
  width: 100%;
  height: 100%;
}
</style>
